// src/pages/api/api.js
import axios from "axios";

/**
 * Instância da API
 * - Em dev: /api → é redirecionado pelo proxy (localhost:5000)
 * - Em prod: /api → é redirecionado pelo Nginx (porta 5000 no VPS)
 */
const api = axios.create({
  baseURL: "/api",
  headers: { "Content-Type": "application/json" },
  withCredentials: false,
});

/**
 * Helper padrão para lidar com o envelope { success, data, message }
 * e também com respostas "nuas" (array/objeto).
 * Devolve sempre: [data, err, meta]
 */
export async function handleApi(promise) {
  try {
    const res = await promise;
    const payload = res?.data;

    if (
      payload &&
      typeof payload === "object" &&
      Object.prototype.hasOwnProperty.call(payload, "success")
    ) {
      const success = !!payload.success;
      const message = payload.message ?? null;
      const severity = payload.severity ?? (success ? "success" : "error");
      return [payload.data ?? null, null, { success, message, severity }];
    }

    return [payload ?? null, null, { success: true, message: null, severity: "success" }];
  } catch (e) {
    const message =
      e?.response?.data?.message ||
      e?.response?.data?.Message ||
      e?.response?.data ||
      e?.message ||
      "Erro de comunicação";
    return [null, message, { success: false, message, severity: "error" }];
  }
}

export default api;
